import { APP_EED } from '@/features/app-eed/container/app.builder';
import { APPS } from '@/features/core/container';
import { GroupRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import icon from '../assets/app-maintenance.svg?vue';

export const APP_MAINTENANCE = GroupRole.APP_MAINTENANCE;

export default option(APPS, async () => {
  return {
    name: APP_MAINTENANCE,
    label: 'Überprüfung & Wartung',
    link: {
      to: { name: 'AppMaintenance' },
      icon,
    },
    hiddenForApps: [APP_EED],
    order: 9,
  };
});
